<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      line-form
      show-save-button
      unit="计价方法"
      edit-title
      form-label-width="60px"
      id-key="ValuationId"
      :data="data"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="编号" prop="ValuationNo">
          <span v-if="Mode==0" class="detail-span">{{data.ValuationNo}}</span>
          <el-input v-else v-model="data.ValuationNo" placeholder="请输入编号"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="ValuationName">
          <el-input v-model="data.ValuationName" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ValuationId: 0,
        ValuationNo: "",
        ValuationName: "",
        Sn: 0,
        Status: 1,
      },
      Mode: 1,
      api: require("@/api/ba/valuation").default,
      code_api: require("@/api/sy/serialCode").default,
      rules: {
        ValuationNo: [{ required: true, message: "计价方法编号不能为空" }],
        ValuationName: [{ required: true, message: "计价方法名称不能为空" }],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
      // this.code_api.previewNo("计价方法").then((res) => {
      //   console.log("serialType", res);
      //   if (res.Code == 0) {
      //     this.Mode = res.Data.Mode;
      //     this.data.ValuationNo = res.Data.PreviewNo;
      //   } else {
      //     this.$message.warning("获取计价方法编号失败");
      //   }
      // });
    },
  },
};
</script>